export interface APIError {
  description: string
  type: string
  statusCode: null | number
}

export async function parseAPIError(error: unknown): Promise<APIError> {
  // @ts-expect-error
  if (error?.message === "Failed to fetch")
    return {
      description: "Failed to fetch",
      type: "PREFLIGHT",
      statusCode: 412,
    }
  // @ts-expect-error
  if (error.name === "HTTPError") {
    // @ts-expect-error
    const errorJson = await error.response.json()
    return {
      description: errorJson.error.description,
      type: errorJson.error.type,
      statusCode: errorJson.statusCode,
    }
  }

  return {
    // @ts-expect-error
    description: error.message || "Unknown Error",
    type: "UNKNOWN",
    statusCode: null,
  }
}
